import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "filter-variation-menu" }
const _hoisted_2 = ["onClick"]

import useTranslate from '@/utilities/composables/useTranslate';

interface Variation {
  id: string;
  label: string;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VariationList',
  props: {
    variations: {}
  },
  emits: ['set-variation', 'close-tippy'],
  setup(__props: any, { emit: __emit }) {



//define emits
const emit = __emit;

const { translate } = useTranslate();

const disabledTooltipText = (variation: Variation) => {
  if (variation.disabled) {
    switch (variation.id) {
      case 'excludes':
        return translate('cannotExcludeAll');
      case 'includes':
        return translate('mustIncludeAtLeastOne');
      default:
        return '';
    }
  }
  return '';
};

// emit on click
const setVariation = (variation: Variation) => {
  if (variation.disabled) return;
  emit('set-variation', variation);
  emit('close-tippy');
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variations, (variation) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: variation.id,
        class: _normalizeClass(["filter-variation-menu-item", {
        'text-inactive-text': variation.disabled,
      }]),
        onClick: _withModifiers(($event: any) => (setVariation(variation)), ["stop"])
      }, [
        _createTextVNode(_toDisplayString(variation.label), 1)
      ], 10, _hoisted_2)), [
        [_directive_tooltip, {
        content: disabledTooltipText(variation),
        placement: 'bottom',
        onShow: () => !!variation.disabled,
      }]
      ])
    }), 128))
  ]))
}
}

})